import request from '@/utils/request'

// 行业动态列表(首页无权限)
export function industryNoAuthList(query) {
    return request({
        url: '/material/industry/noAuth/list',
        method: 'get',
        params: query
    })
}

// 行业动态列表
export function industryList(query) {
    return request({
        url: '/material/industry/asphaltNewsList',
        method: 'get',
        params: query
    })
}

// 行业动态详情
export function industryDetail(id) {
    return request({
        url: `/material/industry/asphaltNews/${id}`,
        method: 'get',
    })
}

// 价格列表(首页无权限)
export function zetarPriceNoAuthList(query) {
    return request({
        url: '/material/metatron/price/noAuth/list',
        method: 'get',
        params: query
    })
}

// 价格列表
export function zetarPriceList(query) {
    return request({
        url: '/material/metatron/price/coalAddPriceList',
        method: 'get',
        params: query
    })
}

// 价格列表后
export function zetarPriceListBack(query) {
    return request({
        url: '/material/industry/coalAddPriceList',
        method: 'get',
        params: query
    })
}

// 价格详情
export function zetarPriceDetail(query) {
    return request({
        url: `/material/metatron/price/detailsCoalAddPriceList`,
        method: 'get',
        params:query
    })
}

// 价格详情后
export function zetarPriceDetailBack(id) {
    return request({
        url: `/material/industry/coalAddPrice/${id}`,
        method: 'get',
    })
}

// 产量列表
export function zetaYieldList(query) {
    return request({
        url: '/material/industry/coalAddYieldList',
        method: 'get',
        params: query
    })
}

// 产量详情
export function zetaYieldDetail(id) {
    return request({
        url: `/material/industry/coalAddYield/${id}`,
        method: 'get',
    })
}

// 研究报告列表(首页无权限)
export function zetarReportNoAuthList(query) {
    return request({
        url: '/material/report/noAuth/list',
        method: 'get',
        params: query
    })
}

// 研究报告列表
export function reportList(query) {
    return request({
        url: '/material/report/reportCoalAddList',
        method: 'get',
        params: query
    })
}

// 研究报告详情
export function zetarReportDetail(id) {
    return request({
        url: `/material/report/boardCoalAddInfo/${id}`,
        method: 'get',
    })
}

// 技术及标准列表
export function standardList(query) {
    return request({
        url: '/material/report/coalAddList',
        method: 'get',
        params: query
    })
}

// 技术及标准详情
export function standardDetail(id) {
    return request({
        url: `/material/report/technicalCoalAddInfo/${id}`,
        method: 'get',
    })
}

// 开工率（首页）
export function rateNoAuthList(query) {
    return request({
        url: '/material/metatron/rate/noAuth/rateList',
        method: 'get',
        params: query
    })
}

// 开工率列表
export function rateList(query) {
    return request({
        url: '/material/metatron/rate/rateCoalAddList',
        method: 'get',
        params: query
    })
}

// 开工率详情
export function rateDetail(query) {
    return request({
        url: `/material/metatron/rate/detailsCoalAddList`,
        method: 'get',
        params:query
    })
}

// 利润列表
export function profitList(query) {
    return request({
        url: '/material/metatron/price/coalAddProfitList',
        method: 'get',
        params: query
    })
}

// 利润详情
export function profitDetail(query) {
    return request({
        url: `/material/metatron/price/detailsCoalAddProfitList`,
        method: 'get',
        params:query
    })
}

// 进出口列表
export function exitList(query) {
    return request({
        url: '/material/industry/coalAddExitList',
        method: 'get',
        params: query
    })
}

// 进出口详情
export function exitDetail(id) {
    return request({
        url: `/material/industry/coalAddExit/${id}`,
        method: 'get',
    })
}

// 装置动态列表
export function deviceList(query) {
    return request({
        url: '/material/industry/coalAddDeviceList',
        method: 'get',
        params: query
    })
}

// 装置动态详情
export function deviceDetail(id) {
    return request({
        url: `/material/industry/coalAddDevice/${id}`,
        method: 'get',
    })
}

// 下游产品价格列表
export function downPriceList(query) {
    return request({
        url: '/material/metatron/price/coalAddDownProductList',
        method: 'get',
        params: query
    })
}

// 下游产品价格详情
export function downPriceDetail(query) {
    return request({
        url: `/material/metatron/price/detailsCoalAddDownProductList`,
        method: 'get',
        params:query
    })
}

// 下游产品开工率列表
export function downRateList(query) {
    return request({
        url: '/material/metatron/rate/rateCoalAddDownProductList',
        method: 'get',
        params: query
    })
}

// 下游产品开工率详情
export function downRateDetail(query) {
    return request({
        url: `/material/metatron/rate/detailsCoalAddDownProductList`,
        method: 'get',
        params:query
    })
}

// 下游产品开工率列表（黑炭）
export function downRateXinList(query) {
    return request({
        url: '/material/industry/coalAddCokeBlackList',
        method: 'get',
        params: query
    })
}

// 下游产品开工率详情（黑炭）
export function downRateXinDetail(id) {
    return request({
        url: `/material/industry/coalAddCokeBlack/${id}`,
        method: 'get',
    })
}

// 下游产品产量列表（首页）
export function downYieldNoAuthList(query) {
    return request({
        url: '/material/metatron/yield/noAuth/yieldList',
        method: 'get',
        params: query
    })
}

// 下游产品产量列表
export function downYieldList(query) {
    return request({
        url: '/material/metatron/yield/coalAddDownYieldList',
        method: 'get',
        params: query
    })
}

// 下游产品产量详情
export function downYieldDetail(query) {
    return request({
        url: `/material/metatron/yield/detailsCoalAddDownYieldList`,
        method: 'get',
        params:query
    })
}

// 下游产品产量列表（新闻）
export function downYieldXinList(query) {
    return request({
        url: '/material/industry/coalAddDownYieldList',
        method: 'get',
        params: query
    })
}

// 下游产品产量详情（新闻）
export function downYieldXinDetail(id) {
    return request({
        url: `/material/industry/coalAddDownYield/${id}`,
        method: 'get',
    })
}

// 下游产品进出口列表（首页）
export function downExitNoAuthList(query) {
    return request({
        url: '/material/metatron/exit/noAuth/exitList',
        method: 'get',
        params: query
    })
}

// 下游产品进出口列表
export function downExitList(query) {
    return request({
        url: '/material/metatron/exit/coalAddDownExitList',
        method: 'get',
        params: query
    })
}

// 下游产品进出口详情
export function downExitDetail(query) {
    return request({
        url: `/material/metatron/exit/detailsCoalAddDownExitList`,
        method: 'get',
        params:query
    })
}

// 下游产品利润列表
export function downProfitList(query) {
    return request({
        url: '/material/metatron/price/coalAddDownProfitList',
        method: 'get',
        params: query
    })
}

// 下游产品利润详情
export function downProfitDetail(query) {
    return request({
        url: `/material/metatron/price/detailsCoalAddDownProfitList`,
        method: 'get',
        params:query
    })
}

// 产业链(首页无权限)
export function chainList(query) {
    return request({
        url: '/material/metatron/chain/noAuth/chainPrice',
        method: 'get',
        params: query
    })
}

// 下游库存(首页无权限)
export function stockNoAuthList(query) {
    return request({
        url: '/material/metatron/stock/noAuth/stockList',
        method: 'get',
        params: query
    })
}

// 折线图
export function priceDetailData(query) {
    return request({
        url: `/material/metatron/detail/lineChart`,
        method: 'get',
        params:query
    })
}
